import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router'
import { useEffect } from 'react'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'
import { CommonNumbersWithDesc } from 'pages/settings/pages/compliance/ui/CommonNumbers/CommonNumbersWithDesc'

export const Numbers = observer(() => {
  const { profile_id } = useParams()
  const tollFreeStepsContext = useTollFreeStepsContext()

  const { initNumbersStore, submitForReviewClick } = tollFreeStepsContext

  useEffect(() => {
    initNumbersStore()
  }, [profile_id])

  return (
    <CommonNumbersWithDesc
      store={tollFreeStepsContext}
      nextText='Submit for review'
      nextHandler={() => submitForReviewClick()}
    />
  )
})
